import React from 'react'
import classnames from 'classnames/bind'
import BigNumber from 'bignumber.js'
import { useRouter } from 'next/router'

// Components
import Image from '@/components/common/Image'
import Icon from '@/assets/icons'

// Libs
import useMedia from '@/hooks/useMedia'
import { handleGtmClickCategory } from '@/methods/handleGtmEvent'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { GTM_LOCATION, GtmCategoryClassType } from '@/constants/gtmEvent'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface IThemeCard {
  index: number
  themeId: number
  name: string
  tips: string
  banner: string
  bannerM: string
}

const isEven = (value: number) => value % 2 == 0

const ThemeCard = (props: IThemeCard) => {
  const { index, themeId, name, tips, banner, bannerM } = props
  const { isMobile, isTablet } = useMedia()
  const router = useRouter()

  const MAX = 5
  const SPAN_STYLE = {
    SPAN_TWO: 2,
    SPAN_THREE: 3,
  }
  const SPAN_STYLE_ID: any = {
    '1': SPAN_STYLE.SPAN_TWO,
    '2': SPAN_STYLE.SPAN_TWO,
    '3': SPAN_STYLE.SPAN_THREE,
    '4': SPAN_STYLE.SPAN_THREE,
    '5': SPAN_STYLE.SPAN_THREE,
  }
  const SPAN_STYLE_ID_DEFAULT = 1

  const getGridItemSpanValue = (gridItemIndex: number) => {
    const gridItemNo = gridItemIndex + 1
    const girdItemMultiple = new BigNumber(new BigNumber(gridItemNo).dividedBy(MAX).toFixed(0, BigNumber.ROUND_DOWN)).toNumber()
    const hasRemainder = new BigNumber(gridItemNo).mod(MAX).toNumber() !== 0
    let styleIndex = SPAN_STYLE_ID_DEFAULT

    if (girdItemMultiple <= 1 && gridItemNo <= MAX) {
      styleIndex = gridItemNo
    }

    if (girdItemMultiple >= 1 && gridItemNo > MAX) {
      styleIndex = new BigNumber(
        new BigNumber(gridItemNo).minus(new BigNumber(girdItemMultiple).multipliedBy(MAX)).toFixed(0, BigNumber.ROUND_DOWN),
      ).toNumber()
    }

    if (girdItemMultiple >= 1 && gridItemNo > MAX && !hasRemainder) {
      styleIndex = 3
    }

    return SPAN_STYLE_ID[`${styleIndex}`]
  }

  return (
    <div
      onClick={() => {
        handleRoutePushWithQuery({ router, pathname: ROUTE_PATH.MALL, query: { theme_id: themeId } })
        handleGtmClickCategory({
          clickText: name,
          classType: GtmCategoryClassType.THEME,
          location: GTM_LOCATION.MALL,
        })
      }}
      className={cx('theme-card', `theme-card--span-${getGridItemSpanValue(index) === SPAN_STYLE.SPAN_TWO ? 'two' : 'three'}`)}
    >
      <div className={cx('theme-card__background')}>
        <Image
          src={isMobile || isTablet ? bannerM : banner}
          fill
          alt='theme-background'
          style={{ objectFit: 'cover' }}
          sizes='(max-width: 500px) 40vw,(max-width: 1000px) 40vw,(max-width: 1440px) 40vw, 30vw'
        />
      </div>
      <div
        className={cx('theme-card__background-mask', {
          'theme-card__background-mask--odd': !isEven(index + 1),
          'theme-card__background-mask--even': isEven(index + 1),
        })}
      ></div>

      <div className={cx('theme-card__text')}>
        <div className={cx('theme-card__text-left')}>
          <div className={cx('theme-card__title')}>{name}</div>
          <div className={cx('theme-card__tip')}>{tips}</div>
        </div>
        <div className={cx('theme-card__text-right')}>
          <Icon.ArrowRight />
        </div>
      </div>
    </div>
  )
}

export default ThemeCard
